import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Assets/Images/white-logo.png";
import fb from "../../Assets/Images/iconFb.png";
import linkedIn from "../../Assets/Images/IconLinkedIn.png";
import building from "../../Assets/Images/Building 2-icon.png";
import building2 from "../../Assets/Images/Building 1_Image.png";
import "./NewFooter.css";
import "./../HomePage/Technology/AllBanner/DatabaseBanner.css";

const NewFooter = () => {
  return (
    <footer id="footer">
      {/* ===== Top Section ===== */}
      <div
        className="footer-content pb-4"
        style={{
          backgroundColor: "#0B1437",
          color: "#fff",
          marginTop: "0",
        }}
      >
        <div className="container-fluid px-5">
          <div className="row gy-4 align-items-start py-5">
            {/* Company Info */}
            <div className="col-12 col-lg-2 g-0 text-center text-lg-start">
              <div>
                <img src={logo} alt="company-logo" className="mb-3" />
              </div>
              <div className="fw-semibold mb-3 sub-heading">
                Quad Theory Ltd.
              </div>

              <div className="d-flex justify-content-center justify-content-lg-start align-items-center gap-3">
                <a
                  className="footer-li email-text"
                  href="https://www.facebook.com/QuadTheoryLtd"
                  target="_blank"
                >
                  <img src={fb} alt="Facebook" />
                </a>
                <a
                  className="footer-li email-text"
                  href="https://www.linkedin.com/company/quad-theory-ltd"
                  target="_blank"
                >
                  <img src={linkedIn} alt="LinkedIn" />
                </a>
              </div>
            </div>

            {/* Bangladesh Office */}
            <div className="col-12 col-lg-3">
              <div>
                <img src={building} alt="Bangladesh Office" className="mb-4" />
              </div>
              <p className="mb-1 fw-semibold fqa-text">Bangladesh</p>
              <p className="mb-1 fqa-text" style={{ color: "#BDBDBD" }}>
                Banasree-B, Road-1, <br /> House-21, Dhaka-1219
              </p>
              <p className="mb-1 small fw-semibold fqa-text">Email Us</p>
              <a
                href="mailto:info@quadtheoryltd.com"
                className="text-white email-text fqa-text small"
              >
                info@quadtheoryltd.com
              </a>
            </div>

            {/* UK Office */}
            <div className="col-12 col-lg-2 px-0">
              <div>
                <img src={building2} alt="UK Office" className="mb-4" />
              </div>
              <p className="mb-1 fqa-text fw-semibold">United Kingdom</p>
              <p className="mb-1 small fqa-text" style={{ color: "#BDBDBD" }}>
                Brayford Square, <br /> London, E1 0SG
              </p>
              <p className="mb-1 fqa-text small fw-semibold">Call Us</p>
              <a
                href="tel:+8801776013574"
                className="text-white email-text fqa-text small"
              >
                +8801776013574
              </a>
            </div>

            {/* Services */}
            <div className="col-12 col-lg-2">
              <h6 className="fw-semibold fqa-text mb-4">Services</h6>
              <ul className="list-unstyled small mb-0 mb-4">
                <li className="mb-4">
                  <Link
                    to="/services/data-analytics"
                    className="text-white email-text fqa-text text-decoration-none"
                  >
                    Data Analysis
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/services/developers-for-hire"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    Developers for Hire
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/services/web-development"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    Web Development
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/services/software-consulting"
                    className="text-white email-text fqa-text text-decoration-none"
                  >
                    Software Consulting
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/services/mobile-app-development"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    Mobile App Development
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/custom-software-development"
                    className="text-white email-text fqa-text text-decoration-none"
                  >
                    Custom Software Development
                  </Link>
                </li>
              </ul>
            </div>

            {/* Technologies */}
            <div className="col-12 col-lg-2">
              <h6 className="fw-semibold mb-4 fqa-text">Technologies</h6>
              <ul className="list-unstyled small">
                <li className="mb-4">
                  <Link
                    to="/technologies"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    All Technologies
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/technologies/web"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    Web Technologies
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/technologies/mobile"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    Mobile Technologies
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/technologies/ui-ux"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    UX/UI Design
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/technologies/database"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    Database
                  </Link>
                </li>
                <li>
                  <Link
                    to="/technologies/cloud"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    Cloud
                  </Link>
                </li>
              </ul>
            </div>

            {/* Links */}
            <div className="col-12 col-lg-1">
              <h6 className="fw-semibold mb-4 fqa-text">Links</h6>
              <ul className="list-unstyled small mb-0">
                <li className="mb-4">
                  <Link
                    to="/"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    Home
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/career"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    Career
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact-us"
                    className="text-white fqa-text email-text text-decoration-none"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Footer Bottom ===== */}
      <div
        className="text-center py-2"
        style={{
          backgroundColor: "#E8F8FC",
          color: "#0B4F5D",
          fontSize: "14px",
          letterSpacing: "0.3px",
        }}
      >
        © 2026 Quad Theory Ltd
      </div>
    </footer>
  );
};

export default NewFooter;
